var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { Box, Typography } from "@mui/material";
import { useState } from "react";
import { useUpdatePlayer } from "../ApiProvider";
import ErrorSnackbar from "../utils/ErrorSnackbar";
import { playerDisplayName } from "../players/PlayerDisplayNameLink";
import { PlayerForm } from "../players/PlayerForm";
/**
 * First-run profile step, shared by fresh signup and the accept-invite bridge.
 * Reuses the standard `PlayerForm` behind a personal welcome; Save and
 * "Skip for now" both call `onDone`, which the caller points at the right
 * destination (Home hub for signup, the joined team for invites).
 */
export var ProfileSetup = function (_a) {
    var player = _a.player, onDone = _a.onDone;
    var _b = __read(useState(false), 2), error = _b[0], setError = _b[1];
    var firstName = playerDisplayName(player).split(" ")[0];
    var mutation = useUpdatePlayer({
        id: player.id,
        onMutate: function () { return setError(false); },
        onSuccess: function (data) {
            onDone();
            return data.data;
        },
        onError: function () { return setError(true); },
    });
    return (_jsxs(Box, { sx: { maxWidth: 640, mx: "auto", p: 2 }, children: [_jsxs(Typography, { variant: "h5", sx: { fontWeight: 700 }, children: ["Welcome", firstName ? ", ".concat(firstName) : "", " \u2014 first, tell us about your soccer profile"] }), _jsx(Typography, { variant: "body2", color: "text.secondary", sx: { mt: 1, mb: 2 }, children: "This helps teammates and managers know your position and style. You can change it anytime." }), _jsx(PlayerForm, { player: player, submitLabel: "Save", cancelLabel: "Skip for now", isSubmitting: mutation.isLoading, onSubmit: function (data) { return mutation.mutate(data); }, onCancel: onDone }), _jsx(ErrorSnackbar, { open: error, message: "Failed to save your profile. Please try again.", onClose: function () { return setError(false); } })] }));
};
